import Modal from '../helpers/Modal';
import Cookies from '../helpers/Cookies';

export default class BoardApplicationModal {
    constructor(root) {
        this.root = root;
        this.cookies = new Cookies();
        this.form_data = window.theme.forms.board_application;
        this.form_root = this.root.querySelector('.gform_wrapper, .gform_confirmation_wrapper');
        this.position_title = this.root.querySelector('.js-board-application-modal-title');

        this.modal = new Modal(this.root, (dataset) => {
            let position_title_field = this.root.querySelector('#input_' + this.form_data.id + '_' + this.form_data.fields.position_name);

            if(position_title_field && dataset) {
                this.cookies.set('last-board-app', dataset.positionTitle, 1);
                position_title_field.value = dataset.positionTitle;
                this.position_title.innerText = dataset.positionTitle;
            } else if(position_title_field) {
                let position_title = this.cookies.get('last-board-app');

                this.position_title.innerText = position_title;
            }
        },
        () => {

        });

        if(this.form_root.classList.contains('gform_validation_error') || this.form_root.classList.contains('gform_confirmation_wrapper')) {
            this.modal.open();
        }
    }
}
